import * as React from 'react';
import { IconFactory } from '../IconFactory/IconFactory';
import { IConfigObj } from '@makemydeal/dr-common-utils';
import { SuccessMessageContainer } from './styledSuccessMessage';

export interface ISuccessMessageProps {
    staticImages: IConfigObj;
    clickClose?: () => void;
    message: string;
}

const renderCloseButton = (clickClose, staticImages) => (
    <div className="success-message__close" data-testid="success-close" onClick={clickClose}>
        <IconFactory staticImages={staticImages} icon="closeX" />
    </div>
);

export const SuccessMessage: React.FC<ISuccessMessageProps> = ({ staticImages, clickClose, message }) => {
    return (
        <SuccessMessageContainer>
            <div className="success-message__outer-container">
                <div className="success-message__inner-container">
                    <div className="success-message__icon">
                        <IconFactory staticImages={staticImages} icon="info" />
                    </div>
                    <div data-testid="success-message" className="success-message">
                        <span className="success-message__title">Success: </span>
                        <span className="success-message__content">{message}</span>
                    </div>
                    {clickClose && renderCloseButton(clickClose, staticImages)}
                </div>
            </div>
        </SuccessMessageContainer>
    );
};
